import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {OwlModule} from 'angular-owl-carousel';
import {LazyLoadImageModule} from 'ng-lazyload-image';

import {SharedModule} from '../../shared/shared.module';
import {AiComponent} from './index/ai.component';
import {AiComponent as ExclusiveAiComponent} from '../exclusive/products/ai/ai.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {ProductsModule} from '../products/products.module';

@NgModule({
    declarations: [
        AiComponent,
        ExclusiveAiComponent
    ],

    imports: [
        CommonModule,
        RouterModule,
        NgbModule,
        OwlModule,
        SharedModule,
        LazyLoadImageModule,
        ReactiveFormsModule,
        FormsModule,
        ProductsModule
    ]
})

export class AiModule {
}
